import React from "react";
import { GenerateVisitsWarningsMutation } from "~/graphql/__generated__/graphql";
import { getVisitWarningLabels, WarningSeverityValue } from "@caredna-marlin/utils/warnings"
import VisitWarningLabel from "./VisitWarningLabel";

type Props = {
  visitWarnings: NonNullable<GenerateVisitsWarningsMutation["generateVisitWarnings"]>["visitWarnings"];
  resources: { provider: {id: number, firstName: string, lastName: string} | null}[]
};

const VisitWarningList: React.FC<Props> = ({visitWarnings, resources}) => {
  const normalizedVisitWarnings = {
        ...visitWarnings,
        resourceRequirementProviderTypes: visitWarnings.resourceRequirementProviderTypes ?? undefined,
        teamMismatch: visitWarnings.teamMismatch ?? undefined,
        severity: visitWarnings.severity as WarningSeverityValue,
        visitId: visitWarnings.visitId,
      }
  const labels = getVisitWarningLabels(normalizedVisitWarnings, resources)

  if (!labels.length) return null;

  return (
    <VisitWarningLabel labels={labels}></VisitWarningLabel>
  );
};

export default VisitWarningList;
